import styled from "styled-components";

export const Layout = styled.div({
  backgroundColor: "#040404",
  height: "100svh",
  width: "100vw",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "calc(10px + 2vmin)",
  color: "white",
});
